export const CardItem = {
    maxWidth: '736px',
    width: '100%',
    overflow: "visible",
}

export const CardImageMobile = {
    maxWidth: '600px',
    width: 'calc(100%+24px)',
    maxHeight: '600px',
    height: '100%',
    objectFit: 'cover',
    mx: -1.5,
}

export const TypDescription = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    my: 1,
}
